import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import { isTrialExpired } from 'utils/freeTrials';

import Paragraph from 'components/Paragraph';

import { Div } from 'legacyComponents/styled/lib';
import { PlanDescriptionWrapper } from 'apps/payment/styles';

export const PlanDescription = withNamespaces()(
  observer(({ subscription, trialPeriodEnd }) => {
    if (!subscription) {
      return (
        <Div width='50%' display='inline-block' verticalAlign='top'>
          <Paragraph>
            <strong>
              <Trans>
                You currently have{' '}
                <span style={{ textDecoration: 'underline' }}>
                  no active paid plan:
                </span>
              </Trans>
            </strong>
            :
          </Paragraph>
          <PlanDescriptionWrapper>
            <Paragraph>
              <Trans>
                Interested in private workspaces with unlimited CAD storage for
                your Company?
              </Trans>
            </Paragraph>
            <Paragraph>
              <Trans>
                <a href='https://wikifactory.com/pricing/'>Learn more</a> about
                Wikifactory and how our services can help streamline your
                product innovation.
              </Trans>
            </Paragraph>
            <Paragraph>
              <Trans>
                <a href='https://wikifactory.com/business-plan/'>
                  Get in touch
                </a>{' '}
                and we can find the plan that’s right for you.
              </Trans>
            </Paragraph>
          </PlanDescriptionWrapper>
        </Div>
      );
    }
    const { seats } = subscription;
    const { totalSubSeats } = seats;
    const isTrialActive = trialPeriodEnd && !isTrialExpired(trialPeriodEnd);

    return (
      <Div width='50%' display='inline-block' verticalAlign='top'>
        <Paragraph>
          <strong>
            <Trans>Current paid plan: {subscription.plan.name}</Trans>
            {isTrialActive && (
              <>
                {' '}
                <Trans>Free Trial</Trans>
              </>
            )}
          </strong>
          :
        </Paragraph>
        <PlanDescriptionWrapper>
          <Paragraph>
            <span>✓</span> <Trans>Unlimited private projects</Trans>
          </Paragraph>
          <Paragraph>
            <span>✓</span>{' '}
            {isTrialActive ? <Trans>Unlimited</Trans> : totalSubSeats}{' '}
            <Trans>seats for private collaborators</Trans>
          </Paragraph>
          <Paragraph>
            Need more seats or additional functionalities?{' '}
            <a href='https://wikifactory.com/business-plan/'>Get in touch</a>.
          </Paragraph>
        </PlanDescriptionWrapper>
      </Div>
    );
  }),
);

PlanDescription.propTypes = {
  subscription: PropTypes.object,
};
